/**
 * Variant Image Filter
 * Shows only images associated with the currently selected variant
 *
 * Works by reading data-variant-ids attributes on media items
 * which are set in the Liquid template based on variant.featured_media associations
 */

// Inject required CSS
(function () {
  if (document.getElementById("variant-image-filter-styles")) return;
  const style = document.createElement("style");
  style.id = "variant-image-filter-styles";
  style.textContent = `
    .product__media-item.variant-hidden,
    .thumbnail-list__item.variant-hidden {
      display: none !important;
    }
  `;
  document.head.appendChild(style);
})();

class VariantImageFilter {
  constructor(sectionId) {
    this.sectionId = sectionId;
    this.mediaGallery = document.querySelector(`#MediaGallery-${sectionId}`);
    this.thumbnailContainer = document.querySelector(
      `#GalleryThumbnails-${sectionId}`
    );

    if (!this.mediaGallery) return;

    // Check if there are any variant-specific images
    this.variantMediaItems =
      this.mediaGallery.querySelectorAll("[data-variant-ids]");
    if (this.variantMediaItems.length === 0) return;

    this.init();
  }

  init() {
    // Subscribe to variant changes via pub/sub
    if (
      typeof subscribe !== "undefined" &&
      typeof PUB_SUB_EVENTS !== "undefined"
    ) {
      subscribe(
        PUB_SUB_EVENTS.variantChange,
        this.handleVariantChange.bind(this)
      );
    }

    // Also listen for URL changes (back/forward navigation)
    window.addEventListener("popstate", () => {
      setTimeout(() => this.filterByCurrentVariant(), 50);
    });

    // Initial filter based on current URL
    this.filterByCurrentVariant();
  }

  handleVariantChange({ data }) {
    if (!data.variant) return;
    this.filterByVariant(data.variant.id.toString());
  }

  filterByCurrentVariant() {
    // Get current variant from URL
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get("variant");

    if (variantId) {
      this.filterByVariant(variantId);
    } else {
      // Try to get from the hidden variant input
      const productInfo = document.querySelector(
        `product-info[data-section="${this.sectionId}"]`
      );
      if (productInfo) {
        const variantInput = productInfo.querySelector('input[name="id"]');
        if (variantInput && variantInput.value) {
          this.filterByVariant(variantInput.value);
        }
      }
    }
  }

  filterByVariant(variantId) {
    // Get all media items with variant associations
    const allMediaItems = this.mediaGallery.querySelectorAll(
      ".product__media-item"
    );
    let hasVariantSpecificImages = false;

    allMediaItems.forEach((item) => {
      const variantIds = item.getAttribute("data-variant-ids");

      if (variantIds) {
        // This item has variant associations
        hasVariantSpecificImages = true;
        const associatedVariants = variantIds.split(",");

        if (associatedVariants.includes(variantId)) {
          // Show this image - it belongs to the selected variant
          item.classList.remove("variant-hidden");
          item.style.display = "";
        } else {
          // Hide this image - it belongs to a different variant
          item.classList.add("variant-hidden");
          item.style.display = "none";
        }
      } else {
        // No variant association - show it (it's a shared/general image)
        item.classList.remove("variant-hidden");
        item.style.display = "";
      }
    });

    // Also filter thumbnails
    if (this.thumbnailContainer) {
      const allThumbnails = this.thumbnailContainer.querySelectorAll(
        ".thumbnail-list__item"
      );
      allThumbnails.forEach((item) => {
        const variantIds = item.getAttribute("data-variant-ids");

        if (variantIds) {
          const associatedVariants = variantIds.split(",");

          if (associatedVariants.includes(variantId)) {
            item.classList.remove("variant-hidden");
            item.style.display = "";
          } else {
            item.classList.add("variant-hidden");
            item.style.display = "none";
          }
        } else {
          item.classList.remove("variant-hidden");
          item.style.display = "";
        }
      });
    }

    // Update which slider item is active
    this.updateActiveSlide(variantId);
  }

  updateActiveSlide(variantId) {
    const allMediaItems = this.mediaGallery.querySelectorAll(
      ".product__media-item"
    );
    let firstVisibleItem = null;

    allMediaItems.forEach((item) => {
      const variantIds = item.getAttribute("data-variant-ids");
      const isVisible = !item.classList.contains("variant-hidden");

      if (isVisible && !firstVisibleItem) {
        firstVisibleItem = item;
      }

      item.classList.remove("is-active");
    });

    if (firstVisibleItem) {
      firstVisibleItem.classList.add("is-active");
      firstVisibleItem.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "start",
      });
    }
  }
}

// Initialize on DOM ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initVariantImageFilter);
} else {
  initVariantImageFilter();
}

function initVariantImageFilter() {
  // Find all product sections
  const productSections = document.querySelectorAll('[id^="MainProduct-"]');
  productSections.forEach((section) => {
    const sectionId = section.id.replace("MainProduct-", "");
    new VariantImageFilter(sectionId);
  });
}
